export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 p-8 md:p-12 lg:p-16">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 right-10 w-64 h-64 rounded-full bg-background-50 blur-3xl"></div>
            <div className="absolute bottom-10 left-10 w-48 h-48 rounded-full bg-background-50 blur-3xl"></div>
          </div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
                移动阅读
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4">
                随时随地，下拉式漫画随身看
              </h2>
              <p className="text-background-50/90 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                43423漫画网完美适配手机和平板，下拉式漫画专为移动端优化。
                无论在地铁、咖啡厅还是睡前，打开浏览器就能畅享流畅的下拉式阅读体验，
                无需下载任何App，省空间更省心。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 text-background-50/90 text-sm">
                  <div className="w-9 h-9 rounded-lg bg-background-50/20 flex items-center justify-center">
                    <i className="ri-smartphone-line text-background-50"></i>
                  </div>
                  <span>手机端适配</span>
                </div>
                <div className="flex items-center gap-2 text-background-50/90 text-sm">
                  <div className="w-9 h-9 rounded-lg bg-background-50/20 flex items-center justify-center">
                    <i className="ri-tablet-line text-background-50"></i>
                  </div>
                  <span>平板端适配</span>
                </div>
                <div className="flex items-center gap-2 text-background-50/90 text-sm">
                  <div className="w-9 h-9 rounded-lg bg-background-50/20 flex items-center justify-center">
                    <i className="ri-wifi-line text-background-50"></i>
                  </div>
                  <span>无需下载</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-56 md:w-64 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/30 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20showing%20a%20vertical%20scrolling%20comic%20reader%20interface%20with%20colorful%20manga%20panels%2C%20clean%20UI%20design%2C%20warm%20orange%20and%20cream%20color%20theme%2C%20modern%20flat%20design%2C%20app%20interface%20mockup%2C%20professional%20presentation%2C%20isolated%20on%20transparent%20background&width=576&height=1024&seq=app-mockup-01&orientation=portrait"
                  alt="43423漫画网手机端下拉式漫画阅读界面"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}